//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const PatientProfile = createAsyncThunk(
  "PatientProfile",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingPatientProfile(""));
      const response = await UsePortalApi(
        `Patient`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        dispatch(
          gettingPatientProfileSuccess(response[0].entry)
        );
      } else {
        dispatch(
          gettingPatientProfileFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingPatientProfileFailed(error));
    }
  }
);
const PatientProfileSlice = createSlice({
  name: "PatientProfile",
  initialState: {
    Profile: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    gettingPatientProfile: (state, action) => {
      state.Profile = null;
      state.isFetching = true;
      state.error = false;
    },
    gettingPatientProfileSuccess: (state, action) => {
      state.Profile = action.payload;
      state.isFetching = false;
      state.error = false;
    },
    gettingPatientProfileFailed: (state, action) => {
      state.Profile = null;
      state.isFetching = false;
      state.error = true;
    },
    gettingPatientProfileClear: (state, action) => {
      state.Profile = null;
      state.isFetching = false;
      state.error = false;
    },
  },
});
export const {
  gettingPatientProfile,
  gettingPatientProfileSuccess,
  gettingPatientProfileFailed,
  gettingPatientProfileClear,
} = PatientProfileSlice.actions;
export default PatientProfileSlice.reducer;
